import React, { useContext } from "react";

import {
  DiscountQuantityWidgetVariant,
  RequiredButtonProps,
} from "@intelligems/ig-types";
import { DiscountQuantityButtonType } from "@intelligems/ig-types/src/dtos/deprecated/discounts";

import { DiscountQuantityContext } from "../../context";

import { QuantityWidget1 } from "./QuantityWidget1";
import { QuantityWidget4 } from "./QuantityWidget4";

interface ButtonPickerProps extends RequiredButtonProps {
  button: DiscountQuantityButtonType;
}

export const ButtonPicker = (props: ButtonPickerProps) => {
  const { getWidgetConfig } = useContext(DiscountQuantityContext);

  const variant = getWidgetConfig(
    "variant"
  ) as unknown as DiscountQuantityWidgetVariant;

  switch (variant) {
    case "quantityButtonsWidget1":
      return <QuantityWidget1 {...props} />;
    default:
      return <QuantityWidget4 {...props} />;
  }
};
